import {ExtendedEventName} from '../core/reporter';
import {DualReporter} from '../core/DualReporter';
import type {AnalyticsConfig} from '../core/types';

export const createDualReporter = <T extends string>(
  aelConfig: AnalyticsConfig,
  deprecatedConfig: AnalyticsConfig,
  experimentsList: Array<string>,
  filterExperiments: (
    eventName: ExtendedEventName<T>,
    experimentName: unknown,
    experimentsListArg: Array<string>,
  ) => boolean,
) => {
  return new DualReporter<T>(
    aelConfig,
    deprecatedConfig,
    experimentsList,
    filterExperiments,
  );
};
